import styled from 'styled-components';

export const Wrapper = styled.div`
    background-color: #2B2941;
    align-items: baseline;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
`;